import { useEffect } from 'react'

import { REDIRECT_ORIGIN_PARAM } from '@space-shell/constant/redirect'
import { RoleType } from '@space-shell/core/store'
import { useViewAsStore } from '@space-shell/core/store'
import { useSearchParams } from 'react-router-dom'

type LegacyRole = 'OWNER' | 'STUDENT' | 'FREE_STUDENT'

const useRoleFromLegacyClub = () => {
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const transformRole = (roleFromRedirect: LegacyRole) => {
      switch (roleFromRedirect) {
        case 'FREE_STUDENT':
          return RoleType.UserNoAccess
        case 'STUDENT':
          return RoleType.Member
        case 'OWNER':
          return RoleType.Creator
        default:
          return undefined
      }
    }

    const getRoleFromRedirect = () => {
      if (searchParams.get('origin') === REDIRECT_ORIGIN_PARAM) {
        const roleFromRedirect = searchParams.get('role')

        if (!roleFromRedirect) {
          return undefined
        }

        return transformRole(roleFromRedirect as LegacyRole)
      }

      return undefined
    }

    const role = getRoleFromRedirect()
    if (role) {
      useViewAsStore.setState({ role })
    }
  }, [searchParams])
}

export { useRoleFromLegacyClub }
